export default {
  isLoading: false,
  brands: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  brand: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
  status: null
};
